import { render, staticRenderFns } from "./app.vue?vue&type=template&id=821d58fc"
import script from "./app.js?vue&type=script&lang=js&external"
export * from "./app.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports